module.exports = __webpack_public_path__ + "media/images/area/feature/chugoku/related/th/5-9dd58205eef08e8cc254d1a34493abcb.jpg";